/* ============================================================
   STITCH THEME JS — Micro-interacciones, drawer, cart
   ============================================================ */

(function() {
  'use strict';

  // ---- Mobile Drawer ----
  const burger = document.querySelector('.stitch-header__burger');
  const drawer = document.getElementById('header-drawer');
  const drawerClose = document.querySelector('.stitch-drawer__close');
  const drawerOverlay = document.querySelector('.stitch-drawer__overlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (burger) burger.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  // ---- Cart Drawer (placeholder logic) ----
  window.StitchCart = {
    add: function(variantId, qty) {
      qty = qty || 1;
      const formData = new FormData();
      formData.append('form_type', 'product');
      formData.append('utf8', '✓');
      formData.append('id', variantId);
      formData.append('quantity', qty);

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(r => r.json())
      .then(data => {
        if (data.status) {
          console.error('Cart error', data);
          alert(data.description || 'Error al añadir al carrito');
          return;
        }
        // Refresh page or update cart badge
        const badge = document.querySelector('.stitch-cart-badge');
        if (badge) {
          badge.textContent = parseInt(badge.textContent || 0) + qty;
        } else {
          const cartIcon = document.querySelector('.stitch-header__cart');
          if (cartIcon) {
            const b = document.createElement('span');
            b.className = 'stitch-cart-badge';
            b.textContent = qty;
            cartIcon.appendChild(b);
          }
        }
        // Simple feedback animation
        const btn = document.activeElement;
        if (btn && btn.classList.contains('stitch-card__quick-btn')) {
          const orig = btn.textContent;
          btn.textContent = 'Añadido';
          btn.style.background = '#34C759';
          btn.style.color = '#fff';
          setTimeout(() => { btn.textContent = orig; btn.style.background = ''; btn.style.color = ''; }, 1200);
        }
      })
      .catch(err => {
        console.error(err);
        alert('Error de red. Inténtalo de nuevo.');
      });
    }
  };

  // ---- Flash Sale Countdown ----
  const countdownEl = document.querySelector('[data-countdown-end]');
  if (countdownEl) {
    const endStr = countdownEl.getAttribute('data-countdown-end');
    const endDate = new Date(endStr).getTime();
    if (!isNaN(endDate)) {
      function updateCountdown() {
        const now = new Date().getTime();
        const diff = endDate - now;
        if (diff <= 0) {
          countdownEl.querySelector('[data-hours]').textContent = '00';
          countdownEl.querySelector('[data-minutes]').textContent = '00';
          countdownEl.querySelector('[data-seconds]').textContent = '00';
          return;
        }
        const h = Math.floor(diff / (1000 * 60 * 60));
        const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((diff % (1000 * 60)) / 1000);
        const hoursEl = countdownEl.querySelector('[data-hours]');
        const minsEl = countdownEl.querySelector('[data-minutes]');
        const secsEl = countdownEl.querySelector('[data-seconds]');
        if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
        if (minsEl) minsEl.textContent = String(m).padStart(2, '0');
        if (secsEl) secsEl.textContent = String(s).padStart(2, '0');
      }
      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  }

  // ---- Sticky header hide on scroll down, show on scroll up ----
  const header = document.querySelector('.stitch-header');
  if (header) {
    let lastScroll = 0;
    let ticking = false;
    const headerHeight = header.offsetHeight || 86;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          const currentScroll = window.scrollY;
          if (currentScroll <= 10) {
            header.classList.remove('is-hidden');
          } else if (currentScroll > lastScroll && currentScroll > headerHeight) {
            header.classList.add('is-hidden');
          } else {
            header.classList.remove('is-hidden');
          }
          lastScroll = currentScroll;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }
})();
